<template>
  <b-card title="Sayfa Ayarları">
    <b-form-group
      label="Sayfa Anahtarı"
      label-for="slug"
      description="Menü ve bloklarda page:anahtar olarak kullanılır. İlk kayıtta başlıktan oluşturulur ve sonra değişmez."
    >
      <b-form-input
        id="slug"
        :value="itemData.slug || '(kaydedince oluşur)'"
        disabled
      />
    </b-form-group>
    <b-form-group
      label="Sayfa Tipi"
      label-for="page_type"
    >
      <v-select
        id="page_type"
        v-model="itemData.page_type"
        :options="pageTypes"
        label="title"
        :reduce="item => item.value"
        :clearable="false"
      />
    </b-form-group>
    <b-form-group
      label="Bölüm"
      label-for="section"
      description="Kurumsal: /kurumsal/... altında, kurumsal sayfalar arasında listelenir."
    >
      <v-select
        id="section"
        v-model="itemData.section"
        :options="sections"
        label="title"
        :reduce="item => item.value"
        placeholder="Bağımsız sayfa"
      />
    </b-form-group>
    <b-form-group
      label="Sıra No"
      label-for="ordering"
    >
      <b-form-input
        id="ordering"
        v-model="itemData.ordering"
        type="number"
        placeholder="Sıra No"
      />
    </b-form-group>
  </b-card>
</template>
<script>
import { BCard, BFormGroup, BFormInput } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'PageSettings',
  components: {
    BCard,
    BFormGroup,
    BFormInput,
    vSelect,
  },
  data() {
    return {
      pageTypes: [
        { title: 'Metin sayfası', value: 'content' },
        { title: 'Hakkımızda (Hakkımızda modülü)', value: 'about' },
        { title: 'Sertifikalar (Sertifikalar modülü)', value: 'certificates' },
        { title: 'Referanslar (Referanslar modülü)', value: 'references' },
      ],
      sections: [
        { title: 'Kurumsal', value: 'kurumsal' },
      ],
    }
  },
  computed: {
    itemData() {
      return this.$store.getters['contents/dataItem']
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
